var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "status_page" }, [
    _c("h3", [
      _vm.isSX
        ? _c("img", {
            staticClass: "dashboard-icons",
            attrs: {
              src: "/static/images/icons/smartexchange_icon_blue.svg",
              alt: "smartexchange-icon",
            },
          })
        : _c("img", {
            staticClass: "dashboard-icons",
            attrs: {
              src: "/static/images/icons/submission_icon_blue.svg",
              alt: "submission-icon",
            },
          }),
      _c("span", { staticClass: "pl-12" }, [_vm._v("Project Status")]),
    ]),
    _c(
      "div",
      {
        staticClass: "piechart",
        class: { "fix-height": _vm.isCombo, "single-height": !_vm.isCombo },
      },
      [_c("div", { attrs: { id: _vm.id } })]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }